import React from "react";
import { Button as BootstrapButton, ButtonProps } from "react-bootstrap";

interface CustomButtonProps {
  icon?: React.ReactNode
  text?: string
  onClick?: () => void
  variant?: ButtonProps["variant"]
  disabled?: boolean
  testId?: string
}

export const CustomButton = ({
  icon,
  text,
  onClick,
  variant = "outline-primary",
  disabled = false,
  testId,
}: CustomButtonProps) => {
  return (
    <BootstrapButton
      onClick={onClick}
      className="custom-button"
      variant={variant}
      disabled={disabled}
      data-testid={testId}
    >
      {icon && <span className="icon-container">{icon}</span>}
      {text && <span className="text-container">{text}</span>}
    </BootstrapButton>
  );
};